import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { rootRouteRef } from './routes';
import { WorkflowClient, workflowApiRef } from './api/WorkflowApi';

export const workflowPlugin = createPlugin({
  id: 'workflow',
  routes: { root: rootRouteRef },
  apis: [
    createApiFactory({
      api: workflowApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new WorkflowClient({ discoveryApi, fetchApi }),
    }),
  ],
});

/** Runs and the DAG builder, mounted at /workflows-dag. */
export const WorkflowPage = workflowPlugin.provide(
  createRoutableExtension({
    name: 'WorkflowPage',
    component: () =>
      import('./components/WorkflowPage').then(m => m.WorkflowPage),
    mountPoint: rootRouteRef,
  }),
);
